<template>
  <v-row :dense="dense">
    <v-col :align="center? 'center' : ''"
           :cols="cols"
    >
      <v-icon large class="ma-2"
              @click="decrement()"
      >
        mdi-minus-circle
      </v-icon>
      <v-label>{{ initialValue }}</v-label>
      <v-icon large class="ma-2"
              color="green"
              @click="increment()"
      >
        mdi-plus-circle
      </v-icon>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "TouchSpin",
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: -1
    },
    initialValue: {
      type: Number,
      default: 1
    },
    dense: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: false
    },
    cols: {
      type: String,
      default: '12'
    }
  },
  data: () => {
    return {
      value: 1
    }
  },

  methods: {
    isInfinite() {
      if (this.max === -1){
        return true
      }
    },

    isGreaterOrEqualsToMin(value) {
      return this.min >= value
    },

    isLessOrEqualsToMax(value) {
      return value <= this.max
    },

    increment() {
      let value = this.value + 1

      if (this.isInfinite()){
        this.value = value
      } else if (this.isLessOrEqualsToMax(value)){
        this.value = value
      }

      this.$emit('increment', this.value)
    },

    decrement() {
      let value = this.value - 1

      if (this.isGreaterOrEqualsToMin(value)){
        this.value = value
      }

      this.$emit('decrement', this.value)
    },
  }
}
</script>